/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Open_TitleInputs */

const en_us2_workout_open_title = /** @type {(inputs: Workout_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workout is still open`)
};

const pt_br2_workout_open_title = /** @type {(inputs: Workout_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há um treino em aberto`)
};

const es_419_workout_open_title = /** @type {(inputs: Workout_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay un entrenamiento abierto`)
};

const pt_pt2_workout_open_title = /** @type {(inputs: Workout_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há um treino em aberto`)
};

const fr_fr2_workout_open_title = /** @type {(inputs: Workout_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une séance est encore ouverte`)
};

const de_de2_workout_open_title = /** @type {(inputs: Workout_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Training ist noch offen`)
};

const it_it2_workout_open_title = /** @type {(inputs: Workout_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'è ancora un allenamento aperto`)
};

/**
* | output |
* | --- |
* | "A workout is still open" |
*
* @param {Workout_Open_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_open_title = /** @type {((inputs?: Workout_Open_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Open_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_open_title(inputs)
	if (locale === "es-419") return es_419_workout_open_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_open_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_open_title(inputs)
	if (locale === "de-DE") return de_de2_workout_open_title(inputs)
	if (locale === "it-IT") return it_it2_workout_open_title(inputs)
	return en_us2_workout_open_title(inputs)
});
export { workout_open_title as "workout.open_title" }